import "./index.css";
import { clsx } from "clsx";
import type { IRowProps } from "./types";

export const Row = ({
  children,
  gap,
  padding,
  alignmentHorizontal = "start",
  alignmentVertical = "center",
  wrap = false,
  reverse = false,
  fullHeight = false,
  className,
}: IRowProps) => {
  const rootClass = clsx(
    "nuco-row",
    gap && `nuco-row--gap-${gap}`,
    padding && `nuco-row--padding-${padding}`,
    `nuco-row--horizontal-${alignmentHorizontal}`,
    `nuco-row--vertical-${alignmentVertical}`,
    wrap && "nuco-row--wrap",
    reverse && "nuco-row--reverse",
    fullHeight && "nuco-row--fullHeight",
    className,
  );

  return <div className={rootClass}>{children}</div>;
};
